module.exports = __webpack_public_path__ + "static/screen-orari-bezels-dark-063fa0dec5b332137c17c404a1cb2afe.png";